module.exports = __webpack_public_path__ + "static/media/no_think_chats.35af5f5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/no_think_chats.svg
// module id = 91
// module chunks = 0